import { PUBLICATION_TYPE } from '@shared/types/enums';

interface PublicationTitleParams {
    type: string,
    title: string,
    magazineTitle?: string,
    seriesName?: string,
    issueNumber?: string | number
}
export const formatPublicationTitle = (publication: PublicationTitleParams) => {
    if (publication.type === PUBLICATION_TYPE.MagazineIssue) {
        return `${publication.magazineTitle} Vol.${publication.seriesName || ''} No.${publication.issueNumber || ''}`;
    }
    return publication.title;
};
